module.exports = __webpack_public_path__ + "img/TEL.0a4a5def.svg";